/*
 * Anytime Spray waitlist control.
 *
 * Reveals the email field in place when the navy "Sold out — Notify me" button is
 * clicked, or when the visitor arrives on the #notify anchor. Validates the address
 * before the native form posts, and remembers a successful signup on this browser
 * so the same visitor is not asked twice.
 *
 * The form itself is Shopify's native customer form. This script never changes
 * where it posts or what it sends.
 */
(function () {
  var STORAGE_KEY = 'dewy-anytime-waitlist-signed-up';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function readFlag() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function writeFlag() {
    try {
      window.localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {
      /* private browsing — the confirmation still shows for this page view */
    }
  }

  function init(root) {
    var trigger = root.querySelector('[data-notify-trigger]');
    var panel = root.querySelector('[data-notify-panel]');
    var confirmJs = root.querySelector('[data-notify-confirm-js]');
    var email = root.querySelector('[data-notify-email]');
    var error = root.querySelector('[data-notify-error]');
    // The wrapper sits outside the form so the Klaviyo hook's closest() still
    // resolves, so walk down to it rather than up.
    var form = root.querySelector('form');

    // The server rendered its own confirmation: the submit went through on this load.
    if (!trigger || !panel) {
      writeFlag();
      return;
    }

    function expand() {
      if (trigger.hidden) return;
      panel.hidden = false;
      trigger.hidden = true;
      if (email) email.focus();
    }

    function showConfirmation() {
      trigger.hidden = true;
      panel.hidden = true;
      if (confirmJs) confirmJs.hidden = false;
    }

    if (readFlag()) {
      showConfirmation();
      return;
    }

    trigger.addEventListener('click', expand);

    // The bottom-of-page "Notify me" call to action links to #notify. Without this
    // it would land on a collapsed button and cost the visitor a second click.
    if (window.location.hash === '#' + root.id) expand();
    window.addEventListener('hashchange', function () {
      if (window.location.hash === '#' + root.id) expand();
    });

    if (!form || !email) return;

    // Take over validation so the message renders inline instead of in a browser bubble.
    form.setAttribute('novalidate', 'novalidate');

    function clearError() {
      if (!error) return;
      error.hidden = true;
      error.textContent = '';
      email.removeAttribute('aria-invalid');
    }

    function showError(message) {
      if (error) {
        // Unhide before writing: a live region mutated while hidden is not announced.
        error.hidden = false;
        error.textContent = message;
      }
      email.setAttribute('aria-invalid', 'true');
      email.focus();
    }

    email.addEventListener('input', clearError);

    // stopImmediatePropagation as well as preventDefault: the theme's Klaviyo hook
    // binds its own submit listener to this same form, and must not fire on an
    // address we have just rejected.
    function stop(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    form.addEventListener('submit', function (event) {
      var value = email.value.trim();

      if (!value) {
        stop(event);
        showError('Enter your email address so we can let you know.');
        return;
      }

      // Deliberately loose: catches typos without rejecting valid unusual addresses.
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) {
        stop(event);
        showError('That email address does not look right. Check it and try again.');
        return;
      }

      clearError();
    });
  }

  ready(function () {
    var roots = document.querySelectorAll('[data-notify]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  });
})();
